import styled from 'styled-components'

export const FooterBg = styled.footer``